import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';
import { Tooltip } from '~/components';
import { truncateStyles } from '~/pages/StoragePage/components/styles';

interface DatasetNameCellProps {
  name: string;
  description: string;
  id: number;
}

const DatasetNameCell: FC<DatasetNameCellProps> = ({ name, description, id }) => {
  return (
    <Tooltip
      title={
        <Stack>
          <Typography variant="buttonTextSmall">{name}</Typography>
          <Typography>{description}</Typography>
        </Stack>
      }
    >
      <Link style={{ ...truncateStyles, textDecoration: 'none' }} to={`${id}`} relative="path">
        {name}
      </Link>
    </Tooltip>
  );
};

export default DatasetNameCell;
